import React from 'react'
import { getDuration } from 'AccountsUtils'
import Short from 'SVGPath/short-layover.svg'
import Long from 'SVGPath/long-layover.svg'
import { getMappedValue } from '../utils/arabicUtils'

const LayOverBar = ({ current, next }) => {
  const { arrivalDate } = current || {}
  const { departureDate } = next || {}
  const duration = arrivalDate && departureDate ? getDuration(arrivalDate, departureDate) : null
  const hours = parseInt(duration.split('h')[0] || 0, 10)
  return (
    <div className="flex flex-center">
      <If condition={duration}>
        <div className="pwa-layover-bar">
          <div className="flex flex-center flex-middle px-2 py-1">
            <If condition={hours > 3}>
              <Long fill="#a7a7aa" />
              <Else />
              <Short fill="#a7a7aa" />
            </If>
            <p className="pl-2 color-8a fs-13">{`${hours > 3 ? getMappedValue('Long layover') : getMappedValue('Short layover')} : ${duration}`}</p>
          </div>
        </div>
      </If>
    </div>
  )
}

export default LayOverBar
